import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
const _excluded = ["format", "inputRef", "todayLabel", "Input", "clearLabel", "minValidationMessage", "maxValidationMessage"];
import { useEffect, useRef, useState } from 'react';
import { getDatePlaceholder } from '../../utils/Locale';
import { getTextWidth } from '../../utils/MeasureText';
import { DateInput } from '../DateInput/DateInput';
import { TextInput } from '../TextInput/TextInput';
import { MicroDateInputProvider } from './MicroDateInputContext.tsx';
import { useTheme } from 'foundations-theming/utils';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const MicroInput = _ref => {
  let rest = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  const theme = useTheme();
  return /*#__PURE__*/_jsx(MicroDateInputProvider, {
    microInputStyleOverrides: {
      display: 'inline-block',
      height: '25px',
      fontSize: theme.typography['body-100'].fontSize
    },
    children: /*#__PURE__*/_jsx(TextInput, Object.assign({}, rest, {
      paddingBlock: "100"
    }))
  });
};
export const MicroDateInput = _ref2 => {
  let {
      format = 'L',
      inputRef,
      todayLabel = I18n.text('ui.datePicker.today'),
      Input = MicroInput,
      clearLabel = I18n.text('ui.datePicker.clear'),
      minValidationMessage = I18n.text('ui.datePicker.dateBelowMin'),
      maxValidationMessage = I18n.text('ui.datePicker.dateAboveMax')
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  const defaultInputRef = useRef(null);
  const computedInputRef = inputRef || defaultInputRef;
  const [measuredWidth, setMeasuredWidth] = useState(137);
  useEffect(() => {
    const measureInput = () => {
      setMeasuredWidth(Math.ceil(getTextWidth(computedInputRef.current, getDatePlaceholder(format))));
    };
    measureInput();
  }, [format]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_jsx(DateInput, Object.assign({}, rest, {
    format: format,
    iconSize: 14,
    inputRef: computedInputRef,
    inputWidth: measuredWidth,
    todayLabel: todayLabel,
    clearLabel: clearLabel,
    minValidationMessage: minValidationMessage,
    maxValidationMessage: maxValidationMessage,
    Input: Input
  }));
};